import { YouTubePlayerProps } from "./types";
import React, { useEffect, useState } from "react";
import VideoPreviewImage from "./VideoPreviewImage";

const YouTubePlayer = ({
  autoplay = false,
  loop = false,
  muted = false,
  previewImage,
  videoYoutube,
}: YouTubePlayerProps) => {
  const [player, setPlayer] = useState<YT.Player>();
  const [showCta, setShowCta] = useState(false);
  const [showPreviewImage, setShowPreviewImage] = useState(true);
  const playVideo = () => {
    if (player?.playVideo && typeof player.playVideo === "function") {
      player.playVideo();
      setShowPreviewImage(false);
    }
  };
  useEffect(() => {
    // NOTE: airbrake
    if (!window?.YT) {
      return;
    }

    // @ts-expect-error NOTE: check ready
    window.YT.ready(() => {
      if (!window?.YT?.Player) {
        return;
      }
      const ytPlayer = new window.YT.Player(`youtube-player-${videoYoutube}`, {
        height: "",
        width: "",
        host: "https://www.youtube-nocookie.com",
        videoId: videoYoutube,
        events: {
          onReady: (event) => {
            setShowCta(true);
            if (muted) {
              event.target.mute();
            }
            if (autoplay) {
              event.target.playVideo();
              setShowPreviewImage(false);
            }
          },
          onStateChange: (event) => {
            switch (event.data) {
              case window.YT.PlayerState.ENDED:
                if (loop) {
                  event.target.playVideo();
                } else {
                  setShowPreviewImage(true);
                }
                break;
              default:
                break;
            }
          },
        },
      });

      setPlayer(ytPlayer);
    });
  }, [autoplay, loop, muted, videoYoutube]);
  return (
    <div className="Video">
      <div className="Video__player" id={`youtube-player-${videoYoutube}`} />
      {previewImage !== "" && (
        <VideoPreviewImage
          playVideo={playVideo}
          previewImage={previewImage}
          showCta={showCta}
          showPreviewImage={showPreviewImage}
        />
      )}
    </div>
  );
};

export default YouTubePlayer;
